"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getErrorLogsByTaskId } from "@/src/requests/error-log";
export const ERROR_LOG_CACHE_KEY = "error-log";
export function useErrorLogs(taskId, options) {
  const $ = _c(16);
  let t0;
  let t1;
  if ($[0] !== taskId) {
    t0 = [ERROR_LOG_CACHE_KEY, taskId];
    t1 = () => {
      if (!taskId) {
        return [];
      }
      return getErrorLogsByTaskId(taskId);
    };
    $[0] = taskId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = (options?.enabled !== false && !!taskId) ?? false;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const query = useQuery(t3);
  let t4;
  if ($[7] !== query.data) {
    t4 = query.data ?? [];
    $[7] = query.data;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== query.error || $[10] !== query.isError || $[11] !== query.isFetching || $[12] !== query.isLoading || $[13] !== query.refetch || $[14] !== t4) {
    t5 = {
      errorLogs: t4,
      isFetching: query.isFetching,
      isLoading: query.isLoading,
      isError: query.isError,
      error: query.error,
      refetch: query.refetch
    };
    $[9] = query.error;
    $[10] = query.isError;
    $[11] = query.isFetching;
    $[12] = query.isLoading;
    $[13] = query.refetch;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}